@if (educationalMaterialEditForm) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <div class="row g-2 align-items-end">
        <div class="col" formGroupName="name">
          <label for="name">{{ "forms.educationalResource.files.materialName.label." + lang | translate }}*</label>
          <app-tooltip-button key="forms.educationalResource.files.materialName.tooltip" variant="help"></app-tooltip-button>
          <input
            type="text"
            class="form-control"
            id="name"
            [formControlName]="lang"
            [ngClass]="{ 'is-invalid': nameCtrl.invalid && (nameCtrl.dirty || nameCtrl.touched || submitted) }" />
          @if (nameCtrl.invalid && (nameCtrl.dirty || nameCtrl.touched || submitted)) {
            <div class="invalid-feedback">
              @if (nameCtrl.errors.invalidCharacters) {
                <div>{{ "forms.errors.textInput.characters" | translate }}</div>
              }
              @if (nameCtrl.errors.maxlength) {
                <div>
                  {{ "forms.errors.common.maxLength" | translate: { maxLength: nameCtrl.errors['maxlength']['requiredLength']
                  } }}
                </div>
              }
            </div>
          }
        </div>
        <div class="col-auto">
          <button
            type="button"
            class="btn btn-gray"
            (click)="openTranslationsModal(nameI18n)"
            [ngClass]="{ 'is-invalid': names.get(otherLangs[0]).invalid || names.get(otherLangs[1]).invalid }">
            {{ "forms.common.translations.label" | translate }}
          </button>
          <app-tooltip-button key="forms.common.translations.tooltip" variant="help"></app-tooltip-button>
          @if (names.get(otherLangs[0]).invalid || names.get(otherLangs[1]).invalid) {
            <div class="invalid-feedback">
              {{ "forms.errors.common.translations" | translate }}
            </div>
          }
        </div>
      </div>
      <ng-template #nameI18n>
        <div class="modal-header">
          <h5 class="modal-title">{{ "forms.educationalResource.files.materialName.modal.title" | translate }}</h5>
          <button
            type="button"
            class="btn-close"
            [attr.aria-label]="'forms.common.close' | translate"
            (click)="translationsModalRef.hide()"></button>
        </div>
        <div class="modal-body" formGroupName="name">
          <h4>{{ "forms.educationalResource.files.materialName.modal.subtitle" | translate }}</h4>
          <div class="form-group">
            <label for="name2">
              {{ "forms.educationalResource.files.materialName.label." + otherLangs[0] | translate }}
            </label>
            <input
              type="text"
              class="form-control"
              id="name2"
              [formControlName]="otherLangs[0]"
            [ngClass]="{
              'is-invalid':
              names.get(otherLangs[0]).invalid &&
              (names.get(otherLangs[0]).dirty || names.get(otherLangs[0]).touched || submitted)}" />
            @if (
              names.get(otherLangs[0]).invalid &&
              (names.get(otherLangs[0]).dirty || names.get(otherLangs[0]).touched || submitted)) {
              <div
                class="invalid-feedback">
                @if (names.get(otherLangs[0]).errors.invalidCharacters) {
                  <div>
                    {{ "forms.errors.textInput.characters" | translate }}
                  </div>
                }
                @if (names.get(otherLangs[0]).errors.maxlength) {
                  <div>
                    {{ "forms.errors.common.maxLength" | translate: { maxLength:
                    names.get(otherLangs[0]).errors['maxlength']['requiredLength'] } }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label for="name3">
              {{ "forms.educationalResource.files.materialName.label." + otherLangs[1] | translate }}
            </label>
            <input
              type="text"
              class="form-control"
              id="name3"
              [formControlName]="otherLangs[1]"
            [ngClass]="{
              'is-invalid':
              names.get(otherLangs[1]).invalid &&
              (names.get(otherLangs[1]).dirty || names.get(otherLangs[1]).touched || submitted)}" />
            @if (
              names.get(otherLangs[1]).invalid &&
              (names.get(otherLangs[1]).dirty || names.get(otherLangs[1]).touched || submitted)) {
              <div
                class="invalid-feedback">
                @if (names.get(otherLangs[1]).errors.invalidCharacters) {
                  <div>
                    {{ "forms.errors.textInput.characters" | translate }}
                  </div>
                }
                @if (names.get(otherLangs[1]).errors.maxlength) {
                  <div>
                    {{ "forms.errors.common.maxLength" | translate: { maxLength:
                    names.get(otherLangs[1]).errors['maxlength']['requiredLength'] } }}
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-gray"
            [attr.aria-label]="'forms.common.cancel' | translate"
            (click)="translationsModalRef.hide()">
            {{ "forms.common.cancel" | translate }}
          </button>
          <button type="button" class="btn btn-blue" (click)="translationsModalRef.hide()">
            {{ "forms.common.saveChanges" | translate }}
          </button>
        </div>
      </ng-template>
      <!--/modal-->
    </div>
    <!--/name-->
    @for (material of materialDetailsArray.controls; track material; let i = $index) {
      <fieldset class="form-group border-bottom" formArrayName="fileDetails">
        @if (
          material.get('file').value || material.get('link').value) {
          <ng-container
            [formGroupName]="i"
            >
            <h4>{{ i + 1 }}{{ "forms.educationalResource.files.file.title" | translate }}</h4>
            <div class="row g-2">
              @if (material.get('file').value) {
                <div class="form-group col-lg">
                  <ng-container>
                    <label for="{{ 'file' + i }}">
                      {{ "forms.educationalResource.files.file.inputs.file.label" | translate }}*
                    </label>
                    <div class="input-group">
                      <input
                        type="text"
                        readonly
                        class="form-control-plaintext"
                        id="{{ 'file' + i }}"
                        formControlName="file" />
                      <button
                        class="btn btn-outline-gray"
                        type="button"
                        (click)="showReplaceInput[i] = !showReplaceInput[i]">
                        {{ "forms.common.replaceFile" | translate }}
                      </button>
                    </div>
                  </ng-container>
                  @if (showReplaceInput[i]) {
                    <label for="{{ 'newFile' + i }}">
                      {{ "forms.educationalResource.files.file.inputs.file.label" | translate }}*
                    </label>
                    <input
                      type="file"
                      class="form-control"
                      id="{{ 'newFile' + i }}"
                      [lang]="lang"
                      (change)="onFileChange($event, i)" />
                    @if (material.get('newFile')?.hasError('fileTooLarge')) {
                      <div class="invalid-feedback d-block">
                        {{ "forms.educationalResource.files.file.errors.tooLarge" | translate }}
                      </div>
                    }
                  }
                </div>
              } @else {
                <div class="form-group col-lg">
                  <label for="{{ 'link' + i }}">
                    {{ "forms.educationalResource.files.file.inputs.link.label" | translate }}*
                  </label>
                  <div class="input-group">
                    <input
                      type="url"
                      readonly
                      class="form-control-plaintext"
                      id="{{ 'link' + i }}"
                      formControlName="link" />
                    <button
                      class="btn btn-outline-gray"
                      data-testid="replaceLinkButton"
                      type="button"
                      (click)="showReplaceInput[i] = !showReplaceInput[i]">
                      {{ "forms.common.replaceLink" | translate }}
                    </button>
                  </div>
                  @if (showReplaceInput[i]) {
                    <label for="{{ 'newLink' + i }}">
                      {{ "forms.educationalResource.files.file.inputs.link.label" | translate }}*
                    </label>
                    <input
                      type="url"
                      class="form-control"
                      data-testid="replaceLinkInput"
                      id="{{ 'newLink' + i }}"
                      formControlName="newLink"
                  [ngClass]="{
                    'is-invalid':
                    material.get('newLink').invalid &&
                    (material.get('newLink').dirty || material.get('newLink').touched || submitted)
                    }" />
                    @if (
                      material.get('newLink').invalid &&
                      (material.get('newLink').dirty || material.get('newLink').touched || submitted)) {
                      <div
                        class="invalid-feedback">
                        @if (material.get('newLink').errors.pattern) {
                          <div>{{ "forms.common.pattern.url" | translate }}</div>
                        }
                        @if (material.get('newLink').errors.maxlength) {
                          <div>
                            {{ "forms.errors.common.maxLength" | translate: { maxLength:
                            material.get("newLink").errors['maxlength']['requiredLength'] } }}
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
              }
              <!--/file-->
              <!--/link-->
              <div class="form-group col-lg-2">
                <label [for]="'language' + i">
                  {{ "forms.educationalResource.files.file.inputs.language.label" | translate }}*
                </label>
                <app-tooltip-button key="forms.educationalResource.files.file.inputs.language.tooltip" variant="help"></app-tooltip-button>
                <ng-select
                  [items]="languages"
                  bindLabel="value"
                  bindValue="key"
                  [id]="'language' + i"
                  [labelForId]="'language' + i"
                formControlName="language"></ng-select>
                @if (
                  material.get('language').invalid &&
                  (material.get('language').dirty || material.get('language').touched || submitted)) {
                  @if (material.get('language').errors.required) {
                    <div>
                      <small class="text-danger">{{ "forms.common.required" | translate }}</small>
                    </div>
                  }
                }
              </div>
              <!--/language-->
            </div>
            <div class="row g-2 align-items-end" formGroupName="displayName">
              <div class="form-group col">
                <label for="{{ 'displayName' + i }}">
                  {{ "forms.educationalResource.files.file.inputs.displayName.label." + lang | translate }}*
                </label>
                <app-tooltip-button key="forms.educationalResource.files.file.inputs.displayName.tooltip" variant="help"></app-tooltip-button>
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'displayName' + i }}"
                  [formControlName]="lang"
              [ngClass]="{
                'is-invalid':
                materialDetailsArray.at(i).get('displayName.' + lang).invalid &&
                (materialDetailsArray.at(i).get('displayName.' + lang).dirty ||
                materialDetailsArray.at(i).get('displayName.' + lang).touched ||
                submitted)}" />
                @if (
                  materialDetailsArray.at(i).get('displayName.' + lang).invalid &&
                  (materialDetailsArray.at(i).get('displayName.' + lang).dirty ||
                  materialDetailsArray.at(i).get('displayName.' + lang).touched ||
                  submitted)) {
                  <div
                    class="invalid-feedback">
                    @if (materialDetailsArray.at(i).get('displayName.' + lang).errors.required) {
                      <div>
                        {{ "forms.common.required" | translate }}
                      </div>
                    }
                    @if (materialDetailsArray.at(i).get('displayName.' + lang).errors.invalidCharacters) {
                      <div>
                        {{ "forms.errors.textInput.characters" | translate }}
                      </div>
                    }
                    @if (materialDetailsArray.at(i).get('displayName.' + lang).errors.maxlength) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate : { maxLength:
                        materialDetailsArray.at(i).get("displayName." + lang).errors['maxlength']['requiredLength'] } }}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group col-auto">
                <button
                  type="button"
                  class="btn btn-gray"
                  (click)="openTranslationsModal(displayName)"
              [ngClass]="{
                'is-invalid':
                materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid ||
                materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid}">
                  {{ "forms.common.translations.label" | translate }}
                </button>
                <app-tooltip-button key="forms.common.translations.tooltip" variant="help"></app-tooltip-button>
                @if (
                  materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid ||
                  materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid) {
                  <div
                    class="invalid-feedback">
                    {{ "forms.errors.common.translations" | translate }}
                  </div>
                }
              </div>
              <ng-template #displayName>
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ "forms.educationalResource.files.file.inputs.displayName.modal.title" | translate }}
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    [attr.aria-label]="'forms.common.close' | translate"
                    (click)="translationsModalRef.hide()"></button>
                </div>
                <div class="modal-body">
                  <h4>{{ "forms.educationalResource.files.file.inputs.displayName.modal.subtitle" | translate }}</h4>
                  <div class="form-group">
                    <label for="{{ 'displayName2' + i }}">
                      {{ "forms.educationalResource.files.file.inputs.displayName.label." + otherLangs[0] | translate }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="{{ 'displayName2' + i }}"
                      [formControlName]="otherLangs[0]"
                  [ngClass]="{
                    'is-invalid':
                    materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid &&
                    (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).dirty ||
                    materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).touched ||
                    submitted)}" />
                    @if (
                      materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid &&
                      (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).dirty ||
                      materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).touched ||
                      submitted)) {
                      <div
                        class="invalid-feedback">
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).errors.invalidCharacters) {
                          <div>
                            {{ "forms.errors.textInput.characters" | translate }}
                          </div>
                        }
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).errors.maxlength) {
                          <div>
                            {{ "forms.errors.common.maxLength" | translate : { maxLength:
                            materialDetailsArray.at(i).get("displayName." + otherLangs[0]).errors['maxlength']['requiredLength']
                            } }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group">
                    <label for="{{ 'displayName3' + i }}">
                      {{ "forms.educationalResource.files.file.inputs.displayName.label." + otherLangs[1] | translate }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="{{ 'displayName3' + i }}"
                      [formControlName]="otherLangs[1]"
                  [ngClass]="{
                    'is-invalid':
                    materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid &&
                    (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).dirty ||
                    materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).touched ||
                    submitted)}" />
                    @if (
                      materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid &&
                      (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).dirty ||
                      materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).touched ||
                      submitted)) {
                      <div
                        class="invalid-feedback">
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).errors.invalidCharacters) {
                          <div>
                            {{ "forms.errors.textInput.characters" | translate }}
                          </div>
                        }
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).errors.maxlength) {
                          <div>
                            {{ "forms.errors.common.maxLength" | translate : { maxLength:
                            materialDetailsArray.at(i).get("displayName." + otherLangs[1]).errors['maxlength']['requiredLength']
                            } }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-gray"
                    [attr.aria-label]="'forms.common.cancel' | translate"
                    (click)="translationsModalRef.hide()">
                    {{ "forms.common.cancel" | translate }}
                  </button>
                  <button type="button" class="btn btn-blue" (click)="translationsModalRef.hide()">
                    {{ "forms.common.saveChanges" | translate }}
                  </button>
                </div>
              </ng-template>
              <!--/modal-->
            </div>
            <!--/displayName-->
            @if (videoFiles.includes(i)) {
              @for (subtitle of material.get('subtitles')['controls']; track subtitle; let j = $index; let isLast = $last) {
                <div
                  class="border-top pt-1"
                  [ngClass]="{ 'border-bottom mb-2': isLast }">
                  <fieldset formArrayName="subtitles">
                    <div class="row g-2 align-items-end" [formGroupName]="j">
                      <div class="form-group col-lg order-1">
                        @if (subtitle.get('subtitle').value) {
                          <ng-container>
                            <label for="{{ 'subtitle' + i + j }}">
                              {{ "forms.educationalResource.files.file.inputs.subtitles.subtitle" | translate }}*
                            </label>
                            <div class="input-group">
                              <input
                                type="text"
                                readonly
                                class="form-control-plaintext"
                                id="{{ 'subtitle' + i + j }}"
                                formControlName="subtitle" />
                              <button
                                class="btn btn-outline-gray"
                                type="button"
                                (click)="showReplaceSubtitleInput[i][j] = !showReplaceSubtitleInput[i][j]">
                                {{ "forms.common.replaceFile" | translate }}
                              </button>
                            </div>
                          </ng-container>
                          @if (showReplaceSubtitleInput[i][j]) {
                            <label for="{{ 'replaceSubtitle' + i }}">
                              {{ "forms.educationalResource.files.file.inputs.subtitles.subtitle" | translate }}*
                            </label>
                            <input
                              type="file"
                              class="form-control"
                              id="{{ 'replaceSubtitle' + i }}"
                              accept=".vtt"
                              [lang]="lang"
                              (change)="onSubtitleChange($event, i, j)" />
                          }
                        } @else {
                          <label for="{{ 'newSubtitle' + i }}">
                            {{ "forms.educationalResource.files.file.inputs.subtitles.subtitle" | translate }}*
                          </label>
                          <input
                            type="file"
                            class="form-control"
                            id="{{ 'newSubtitle' + i }}"
                            accept=".vtt"
                            [lang]="lang"
                            (change)="onSubtitleChange($event, i, j)" />
                        }
                      </div>
                      <!--/subtitle-->
                      <div class="form-group col-sm-8 col-lg order-2">
                        <label for="{{ 'label' + i + j }}">
                          {{ "forms.educationalResource.files.file.inputs.subtitles.label" | translate }}*
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="{{ 'label' + i + j }}"
                          formControlName="label"
                    [ngClass]="{
                      'is-invalid':
                      subtitle.get('label').invalid &&
                      (subtitle.get('label')['dirty'] || subtitle.get('label').touched || submitted)}" />
                        @if (
                          subtitle.get('label').invalid &&
                          (subtitle.get('label')['dirty'] || subtitle.get('label').touched || submitted)) {
                          <div
                            class="invalid-feedback">
                            @if (subtitle.get('label').errors['required']) {
                              <div>
                                {{ "forms.common.required" | translate }}
                              </div>
                            }
                            @if (subtitle.get('label').errors['invalidCharacters']) {
                              <div>
                                {{ "forms.errors.textInput.characters" | translate }}
                              </div>
                            }
                            @if (subtitle.get('label').errors['maxlength']) {
                              <div>
                                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                                subtitle.get("label").errors['maxlength']['requiredLength'] } }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <!--/label-->
                      <div class="form-group col-sm-4 col-lg order-3">
                        <label [for]="'srclang' + i + j">
                          {{ "forms.educationalResource.files.file.inputs.subtitles.srclang" | translate }}*
                        </label>
                        <ng-select
                          [items]="languages"
                          bindLabel="value"
                          bindValue="key"
                          [id]="'srclang' + i + j"
                          [labelForId]="'srclang' + i + j"
                        formControlName="srclang"></ng-select>
                        @if (
                          subtitle.get('srclang').invalid &&
                          (subtitle.get('srclang')['dirty'] || subtitle.get('srclang').touched || submitted)) {
                          @if (subtitle.get('srclang')['errors']['required']) {
                            <div>
                              <small class="text-danger">{{ "forms.common.required" | translate }}</small>
                            </div>
                          }
                        }
                      </div>
                      <!--/srclang-->
                      <div class="form-group col-lg-auto order-last order-lg-4">
                        <button type="button" class="btn btn-danger" (click)="removeSubtitle(i, j)">
                          <i class="fa fa-trash-o fa-fw" aria-hidden="true"></i>
                          <span class="visually-hidden">{{ "forms.common.delete" | translate }}</span>
                        </button>
                      </div>
                      <!--/actions-->
                      <div class="form-group col-lg-12 order-4">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="{{ 'default' + i + j }}"
                            formControlName="default"
                            (change)="updateDefaultSubtitle($event, i, j)" />
                          <label class="form-check-label" for="{{ 'default' + i + j }}">
                            {{ "forms.educationalResource.files.file.inputs.subtitles.default" | translate }}
                          </label>
                        </div>
                      </div>
                      <!--/default-->
                    </div>
                  </fieldset>
                </div>
              }
              <div class="form-group">
                <button type="button" class="btn btn-gray" (click)="addSubtitle(i)">
                  {{ "forms.educationalResource.files.file.inputs.subtitles.addSubtitle" | translate }}
                </button>
              </div>
            }
            <!--/subtitles-->
            <button type="button" class="btn btn-danger mb-3" (click)="removeMaterial(i)">
              <i class="fa fa-trash-o fa-fw" aria-hidden="true"></i>
              {{ "forms.common.delete" | translate }}
            </button>
          </ng-container>
        } @else {
          <ng-container [formGroupName]="i">
            <h2>{{ i + 1 }}{{ "forms.educationalResource.files.file.title" | translate }}</h2>
            <div class="row g-2">
              @if (!material.get('newLink').value) {
                <div class="form-group col-lg">
                  <label for="{{ 'newMaterialFile' + i }}">
                    {{ "forms.educationalResource.files.file.inputs.file.label" | translate }}*
                  </label>
                  <input
                    type="file"
                    class="form-control"
                    id="{{ 'newMaterialFile' + i }}"
                    [lang]="lang"
                    (change)="onFileChange($event, i)" />
                  @if (material.get('newFile')?.hasError('fileTooLarge')) {
                    <div class="invalid-feedback d-block">
                      {{ "forms.educationalResource.files.file.errors.tooLarge" | translate }}
                    </div>
                  }
                </div>
              }
              <!--/file-->
              @if (!material.get('newFile').value && !material.get('newLink').value) {
                <div
                  class="form-group col-lg-1 text-center"
                  >
                  {{ "forms.educationalResource.files.file.or" | translate }}
                </div>
              }
              @if (!material.get('newFile').value) {
                <div class="form-group col-lg">
                  <label for="{{ 'newMaterialLink' + i }}">
                    {{ "forms.educationalResource.files.file.inputs.link.label" | translate }}*
                  </label>
                  <input
                    type="url"
                    class="form-control"
                    id="{{ 'newMaterialLink' + i }}"
                    formControlName="newLink"
                [ngClass]="{
                  'is-invalid':
                    material.get('newLink').invalid &&
                    (material.get('newLink').dirty || material.get('newLink').touched || submitted)}" />
                  @if (
                    material.get('newLink').invalid &&
                    (material.get('newLink').dirty || material.get('newLink').touched || submitted)) {
                    <div
                      class="invalid-feedback">
                      @if (material.get('newLink').errors.pattern) {
                        <div>{{ "forms.common.pattern.url" | translate }}</div>
                      }
                      @if (material.get('newLink').errors.maxlength) {
                        <div>
                          {{ "forms.errors.common.maxLength" | translate: { maxLength:
                          material.get("newLink").errors['maxlength']['requiredLength'] } }}
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <!--/link-->
              <div class="form-group col-lg-2">
                <label [for]="'newMaterialLanguage' + i">
                  {{ "forms.educationalResource.files.file.inputs.language.label" | translate }}*
                </label>
                <app-tooltip-button key="forms.educationalResource.files.file.inputs.language.tooltip" variant="help"></app-tooltip-button>
                <ng-select
                  [items]="languages"
                  bindLabel="value"
                  bindValue="key"
                  [id]="'newMaterialLanguage' + i"
                  [labelForId]="'newMaterialLanguage' + i"
                formControlName="language"></ng-select>
                @if (
                  material.get('language').invalid &&
                  (material.get('language').dirty || material.get('language').touched || submitted)) {
                  @if (material.get('language').errors.required) {
                    <div>
                      <small class="text-danger">{{ "forms.common.required" | translate }}</small>
                    </div>
                  }
                }
              </div>
              <!--/language-->
            </div>
            <div class="row g-2 align-items-end" formGroupName="displayName">
              <div class="form-group col">
                <label for="{{ 'newMaterialDisplayName' + i }}">
                  {{ "forms.educationalResource.files.file.inputs.displayName.label." + lang | translate }}*
                </label>
                <app-tooltip-button key="forms.educationalResource.files.file.inputs.displayName.tooltip" variant="help"></app-tooltip-button>
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'newMaterialDisplayName' + i }}"
                  [formControlName]="lang"
                [ngClass]="{
                  'is-invalid':
                    materialDetailsArray.at(i).get('displayName.' + lang).invalid &&
                    (materialDetailsArray.at(i).get('displayName.' + lang).dirty ||
                    materialDetailsArray.at(i).get('displayName.' + lang).touched ||
                    submitted)}" />
                @if (
                  materialDetailsArray.at(i).get('displayName.' + lang).invalid &&
                  (materialDetailsArray.at(i).get('displayName.' + lang).dirty ||
                  materialDetailsArray.at(i).get('displayName.' + lang).touched ||
                  submitted)) {
                  <div
                    class="invalid-feedback">
                    @if (materialDetailsArray.at(i).get('displayName.' + lang).errors.required) {
                      <div>
                        {{ "forms.common.required" | translate }}
                      </div>
                    }
                    @if (materialDetailsArray.at(i).get('displayName.' + lang).errors.invalidCharacters) {
                      <div>
                        {{ "forms.errors.textInput.characters" | translate }}
                      </div>
                    }
                    @if (materialDetailsArray.at(i).get('displayName.' + lang).errors.maxlength) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate : { maxLength:
                        materialDetailsArray.at(i).get("displayName." + lang).errors['maxlength']['requiredLength'] } }}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group col-auto">
                <button
                  type="button"
                  class="btn btn-gray"
                  (click)="openTranslationsModal(newMaterialDisplayName)"
                [ngClass]="{
                  'is-invalid':
                    materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid ||
                    materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid}">
                  {{ "forms.common.translations.label" | translate }}
                </button>
                <app-tooltip-button key="forms.common.translations.tooltip" variant="help"></app-tooltip-button>
                @if (
                  materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid ||
                  materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid) {
                  <div
                    class="invalid-feedback">
                    {{ "forms.errors.common.translations" | translate }}
                  </div>
                }
              </div>
              <ng-template #newMaterialDisplayName>
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ "forms.educationalResource.files.file.inputs.displayName.modal.title" | translate }}
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    [attr.aria-label]="'forms.common.close' | translate"
                    (click)="translationsModalRef.hide()"></button>
                </div>
                <div class="modal-body">
                  <h4>{{ "forms.educationalResource.files.file.inputs.displayName.modal.subtitle" | translate }}</h4>
                  <div class="form-group">
                    <label for="{{ 'newMaterialDisplayName2' + i }}">
                      {{ "forms.educationalResource.files.file.inputs.displayName.label." + otherLangs[0] | translate }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="{{ 'newMaterialDisplayName2' + i }}"
                      [formControlName]="otherLangs[0]"
                    [ngClass]="{
                      'is-invalid':
                        materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid &&
                        (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).dirty ||
                          materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).touched ||
                          submitted)}" />
                    @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).invalid &&
                      (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).dirty ||
                      materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).touched ||
                      submitted)) {
                      <div
                        class="invalid-feedback">
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).errors.invalidCharacters) {
                          <div
                            >
                            {{ "forms.errors.textInput.characters" | translate }}
                          </div>
                        }
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[0]).errors.maxlength) {
                          <div>
                            {{ "forms.errors.common.maxLength" | translate : { maxLength:
                            materialDetailsArray.at(i).get("displayName." +
                            otherLangs[0]).errors['maxlength']['requiredLength'] } }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group">
                    <label for="{{ 'newMaterialDisplayName3' + i }}">
                      {{ "forms.educationalResource.files.file.inputs.displayName.label." + otherLangs[1] | translate }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="{{ 'newMaterialDisplayName3' + i }}"
                      [formControlName]="otherLangs[1]"
                    [ngClass]="{
                      'is-invalid':
                        materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid &&
                        (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).dirty ||
                          materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).touched ||
                          submitted)}" />
                    @if (
                      materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).invalid &&
                      (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).dirty ||
                      materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).touched ||
                      submitted)) {
                      <div
                        class="invalid-feedback">
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).errors.invalidCharacters) {
                          <div
                            >
                            {{ "forms.errors.textInput.characters" | translate }}
                          </div>
                        }
                        @if (materialDetailsArray.at(i).get('displayName.' + otherLangs[1]).errors.maxlength) {
                          <div>
                            {{ "forms.errors.common.maxLength" | translate : { maxLength:
                            materialDetailsArray.at(i).get("displayName." +
                            otherLangs[1]).errors['maxlength']['requiredLength'] } }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-gray"
                    [attr.aria-label]="'forms.common.cancel' | translate"
                    (click)="translationsModalRef.hide()">
                    {{ "forms.common.cancel" | translate }}
                  </button>
                  <button type="button" class="btn btn-blue" (click)="translationsModalRef.hide()">
                    {{ "forms.common.saveChanges" | translate }}
                  </button>
                </div>
              </ng-template>
              <!--/modal-->
            </div>
            <!--/displayName-->
            @if (material.get('subtitles')) {
              @for (subtitle of material.get('subtitles')['controls']; track subtitle; let j = $index; let isLast = $last) {
                <div
                  class="border-top pt-1"
                  [ngClass]="{ 'border-bottom mb-2': isLast }">
                  <fieldset formArrayName="subtitles">
                    <div class="row g-2 align-items-end" [formGroupName]="j">
                      <div class="form-group col-lg order-1">
                        <label for="{{ 'newMaterialSubtitle' + i }}">
                          {{ "forms.educationalResource.files.file.inputs.subtitles.subtitle" | translate }}*
                        </label>
                        <input
                          type="file"
                          class="form-control"
                          id="{{ 'newMaterialSubtitle' + i }}"
                          accept=".vtt"
                          [lang]="lang"
                          (change)="onSubtitleChange($event, i, j)" />
                      </div>
                      <!--/subtitle-->
                      <div class="form-group col-sm-8 col-lg order-2">
                        <label for="{{ 'newMaterialLabel' + i + j }}">
                          {{ "forms.educationalResource.files.file.inputs.subtitles.label" | translate }}*
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="{{ 'newMaterialLabel' + i + j }}"
                          formControlName="label"
                      [ngClass]="{
                        'is-invalid':
                          subtitle.get('label').invalid &&
                          (subtitle.get('label')['dirty'] || subtitle.get('label').touched || submitted)}" />
                        @if (
                          subtitle.get('label').invalid &&
                          (subtitle.get('label')['dirty'] || subtitle.get('label').touched || submitted)) {
                          <div
                            class="invalid-feedback">
                            @if (subtitle.get('label')['errors']['required']) {
                              <div>
                                {{ "forms.common.required" | translate }}
                              </div>
                            }
                            @if (subtitle.get('label')['errors']['invalidCharacters']) {
                              <div>
                                {{ "forms.errors.textInput.characters" | translate }}
                              </div>
                            }
                            @if (subtitle.get('label')['errors']['maxlength']) {
                              <div>
                                {{ "forms.errors.common.maxLength" | translate: { maxLength:
                                subtitle.get("label")['errors']['maxlength']['requiredLength'] } }}
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <!--/label-->
                      <div class="form-group col-sm-4 col-lg order-3">
                        <label [for]="'newMaterialSrclang' + i + j">
                          {{ "forms.educationalResource.files.file.inputs.subtitles.srclang" | translate }}*
                        </label>
                        <ng-select
                          [items]="languages"
                          bindLabel="value"
                          bindValue="key"
                          [id]="'newMaterialSrclang' + i + j"
                          [labelForId]="'newMaterialSrclang' + i + j"
                        formControlName="srclang"></ng-select>
                        @if (
                          subtitle.get('srclang').invalid &&
                          (subtitle.get('srclang')['dirty'] || subtitle.get('srclang').touched || submitted)) {
                          @if (subtitle.get('srclang')['errors']['required']) {
                            <div>
                              <small class="text-danger">{{ "forms.common.required" | translate }}</small>
                            </div>
                          }
                        }
                      </div>
                      <!--/srclang-->
                      <div class="form-group col-lg-auto order-last order-lg-4">
                        <button type="button" class="btn btn-danger" (click)="removeSubtitle(i, j)">
                          <i class="fa fa-trash-o fa-fw" aria-hidden="true"></i>
                          <span class="visually-hidden">{{ "forms.common.delete" | translate }}</span>
                        </button>
                      </div>
                      <!--/actions-->
                      <div class="form-group col-lg-12 order-4">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="{{ 'newMaterialDefault' + i + j }}"
                            formControlName="default"
                            (change)="updateDefaultSubtitle($event, i, j)" />
                          <label class="form-check-label" for="{{ 'newMaterialDefault' + i + j }}">
                            {{ "forms.educationalResource.files.file.inputs.subtitles.default" | translate }}
                          </label>
                        </div>
                      </div>
                      <!--/default-->
                    </div>
                  </fieldset>
                </div>
              }
              <div class="form-group">
                <button type="button" class="btn btn-gray" (click)="addSubtitle(i)">
                  {{ "forms.educationalResource.files.file.inputs.subtitles.addSubtitle" | translate }}
                </button>
              </div>
            }
            <!--/subtitles-->
            <button type="button" class="btn btn-danger mb-3" (click)="removeMaterial(i)">
              <i class="fa fa-trash-o fa-fw" aria-hidden="true"></i>
              {{ "forms.common.delete" | translate }}
            </button>
          </ng-container>
        }
      </fieldset>
    }
    <!--/files-->
    @if (submitted && materialDetailsArray.errors) {
      <alert type="warning">
        @if (materialDetailsArray.errors.required) {
          <div>
            {{ "forms.educationalResource.files.file.error" | translate }}
          </div>
        }
      </alert>
    }
    <div class="form-group">
      <button type="button" class="btn btn-gray" (click)="addMaterial()">
        {{ "forms.educationalResource.files.file.addFile" | translate }}
      </button>
    </div>
    @for (response of uploadResponses; track response) {
      @if (response) {
        @if (response.status === 'error') {
          <div class="form-group">{{ response.message }}</div>
        }
        @if (response.status === 'progress') {
          <div class="form-group">
            <progressbar
              [max]="100"
              [value]="+response.message"
              >{{ response.message }}%</progressbar>
          </div>
        }
      }
    }
    <div class="row justify-content-end">
      <div class="col-auto">
        <button type="button" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-blue">{{ "forms.common.next" | translate }}</button>
      </div>
    </div>
  </form>
}
